import { find, forEach, get, isEqual, result } from 'lodash';

export function updateUrl({ url, parameters = {}, keys = [], filters = {} } = {}) {
  url.search = '';

  forEach(keys, (key) => {
    const val = get(parameters, key);
    if (val) {
      const filter = get(filters, key);
      const parameterSlug = result(
        find(filter, ({ id, slug }) => isEqual(id, val) || isEqual(slug, val)),
        'slug',
      );

      url.searchParams.set(`dsp_${key}`, parameterSlug ?? val);
    }
  });

  window.history.replaceState(null, null, url);

  return url;
}

export function buildSearchParams({ parameters, keys, customFilterId, pageId }) {
  const searchParams = new URLSearchParams();

  forEach(keys, (key) => {
    const val = get(parameters, key);
    if (val) {
      searchParams.set(`dsp_${key}`, val);
    }
  });

  const currentUrl = new URL(window.location);
  if (currentUrl.searchParams.has('lang')) {
    searchParams.set('lang', currentUrl.searchParams.get('lang'));
  }

  // set custom filter (if present) on searchParams for the json search request
  customFilterId && searchParams.set('custom_filter', customFilterId);

  // set page ID (is present) for use with page-specific ACF content in rendered output
  pageId && searchParams.set('wp_page', pageId);

  return searchParams;
}
